var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrack3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 49,
    viewBox: "0 0 125 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.7609 21.4288L74.922 21.312L75.0662 21.175L83.0738 13.5678C84.9422 11.7929 86 9.32884 86 6.75183C86 4.80216 87.6356 3.25149 89.5825 3.35533L104.268 4.13857C112.298 4.56685 118.981 10.4586 120.412 18.3718L121.574 24.7967C123.572 35.8409 115.085 46 103.861 46H34.39C31.9268 46 29.7566 44.3811 29.0547 42.0201L28.8278 41.2569C26.5773 33.6873 17.3373 30.861 11.2374 35.8765C7.95017 38.5793 3 36.2409 3 31.9851V26.5V5.39246C3 4.96266 3.10418 4.53927 3.3036 4.15854C4.0348 2.76262 6.0647 2.86077 6.65781 4.32072L8.05999 7.77224C9.17072 10.5064 11.6091 12.4774 14.5154 12.9902C19.1629 13.8104 23.5998 10.7217 24.444 6.07845L25.0037 3H41.6831C46.2764 3 50 6.72363 50 11.3169C50 23.0082 63.2551 29.7705 72.7205 22.9081L74.7609 21.4288Z",
    stroke: "currentColor",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack3);
export default __webpack_public_path__ + "static/media/track3.88a1656d.svg";
export { ForwardRef as ReactComponent };